<script>
    import YearlyList from './YearlyList.svelte';
    
    // Stores
    import {YearsList} from '../../store';

</script>

<div class="w-100 list-container list-group-overflow-hidden rounded">
    {#each $YearsList as yearsListItem}
        <YearlyList collapseId={yearsListItem.collapseId} listItemId={yearsListItem.collapseId} listName={yearsListItem.name} totalExp={yearsListItem.total} active={yearsListItem.active} monthsList={yearsListItem.monthsList} />
    {/each}
</div>